import Axios from "../plugins/Axios";
import { CancelReturn as CancelReturnModel } from "../models/Return";

const getLatestReturns = async () => {
  try {
    const { data } = await Axios.get(`/returns/latest`);
    return {
      success: true,
      data: data.data,
    };
  } catch (error: any) {
    return {
      ...error,
      success: false,
      data: [],
    };
  }
};

const getReturnById = async (id: string) => {
  try {
    const { data } = await Axios.get(`/returns/${id}`);
    return {
      success: true,
      data: data?.data,
    };
  } catch (error: any) {
    return {
      ...error,
      success: false,
      data: null,
    };
  }
};

const cancelReturn = async (id: string, body: CancelReturnModel) => {
  try {
    await Axios.post(`/returns/${id}/cancel`, body);
    return {
      success: true,
    };
  } catch (error: any) {
    return {
      ...error,
      success: false,
    };
  }
};

export {
  getLatestReturns as GetLatestReturns,
  getReturnById as GetReturnById,
  cancelReturn as CancelReturn,
};
